module.exports = __webpack_public_path__ + "static/android-icon-192x192-eeba28dca9134cd7f6a17ce3be362ac6.png";